import React from 'react';
import * as S from './styled';
export const DropdownHeading = ({ label }) => (React.createElement(S.Container, null, label));
